import type { WithContext, BreadcrumbList, ListItem, Product } from 'schema-dts'
import type { HeadListItem } from '../../entities/HeadListItem'
import { useJsonld } from '~~/modules/head/composables/useHeadSchemaComposable/useJsonld'
import {
  organizationBaseSpain,
  breadcrumbListBase,
  lodgingBusinessBase,
  productBase,
  websiteBase,
} from './constants'

export type productParams = {
  name: string
  description: string
  image: string
  sku: string
  aggregateRating: {
    ratingValue: number
    bestRating: number
    ratingCount: number
  }
}

const useHeadSchemaComposable = () => {
  const organizationSchema = () => {
    useJsonld(organizationBaseSpain)
  }

  const listItemGenerator = function (item: HeadListItem): ListItem {
    const listItem: ListItem = {
      '@type': 'ListItem',
      position: item.position,
      name: item.name,
      item: item.url,
    }

    return listItem
  }

  const breadcrumbSchema = (items: HeadListItem[]) => {
    if (items.length === 0) {
      return
    }

    const itemListElement = items.map(item => listItemGenerator(item))

    const breadCrumbList: WithContext<BreadcrumbList> = {
      ...breadcrumbListBase,
      itemListElement,
    }

    useJsonld(breadCrumbList)
  }

  const lodgingBusinessSchema = (params: {
    name: string
    image: string
    priceRange: string
    address: {
      name: string
    }
  }) => {
    const lodgingBusinessClean = JSON.parse(JSON.stringify(lodgingBusinessBase))

    lodgingBusinessClean.name = params.name
    lodgingBusinessClean.image = params.image
    lodgingBusinessClean.priceRange = t('head.schema.lodgingBusiness.price', {
      price: params.priceRange,
    })
    lodgingBusinessClean.address.name = params.address.name

    useJsonld(lodgingBusinessClean)
  }

  const productSchema = (params: productParams) => {
    const productClean: WithContext<Product> = JSON.parse(
      JSON.stringify(productBase),
    )

    productClean.name = params.name
    productClean.description = params.description
    productClean.image = params.image
    productClean.sku = params.sku

    productClean.aggregateRating = {
      '@type': 'AggregateRating',
      ratingValue: params.aggregateRating.ratingValue,
      bestRating: params.aggregateRating.bestRating,
      ratingCount: params.aggregateRating.ratingCount,
    }

    useJsonld(productClean)
  }

  const websiteSchema = () => {
    useJsonld(websiteBase)
  }

  return {
    organizationSchema,
    breadcrumbSchema,
    lodgingBusinessSchema,
    productSchema,
    websiteSchema,
  }
}

export { useHeadSchemaComposable }
export default useHeadSchemaComposable
